import { Component, Input } from '@angular/core';
import { AbstractControl, UntypedFormArray } from '@angular/forms';
import { FormInstrument } from './form-instrument';

@Component({
  selector: 'libero-selected-instrument-toggler',
  templateUrl: './selected-instrument-toggler.component.html',
  styleUrls: ['./selected-instrument-toggler.component.scss'],
  standalone: false
})
export class SelectedInstrumentTogglerComponent {
  @Input() public formName!: AbstractControl;

  public instrumentRemovable(): boolean {
    return !this.formName.value['cash'];
  }

  public removeSelectedInstrument(): void {
    const selectedInstruments = this.formName.parent as UntypedFormArray;
    const instrumentId = this.formName.value.id;

    selectedInstruments.removeAt(selectedInstruments.value.findIndex((instrument: FormInstrument) => instrument.id === instrumentId))
  }
}
